import { apiClient } from '~services/api'
import { NftDetailsInput, NftDetailsResponse, NftsResponse } from '~types/nfts'

export const getNfts = (): Promise<NftsResponse> => {
  return apiClient.get<NftsResponse, NftsResponse>(`/nfts`)
}

export const getNftDetails = ({ nftId }: NftDetailsInput): Promise<NftDetailsResponse> => {
  return apiClient.get<NftDetailsResponse, NftDetailsResponse>(`/nfts/${nftId}`)
}
